import React, { Component } from 'react'

//import data from '../../data/median-sales-price.csv'
import data from '../../data/median_sales_price_2020.csv'

import {
  boldRed,
  boldBlue,
  veryDarkGray,
  title,
  placeholderText,
  tooltipHeaderPrefix
} from '../../constants'
import LineChart from '../LineChart/'
import Header from '../Header/'
import Footer from '../Footer/'
import Controls from '../Controls/'
import Legend from '../Legend'
import reshapeData from './reshape-data'
import parsePlaces from './parsePlaces'
import parseStateFromUrl from '../../utils/parseStateFromUrl'
import updateQueryStringBatch from '../../utils/updateQueryStringBatch'
import styles from './styles.module.css'

export default class MedianSalesPriceVis extends Component {
  constructor(props) {
    super(props)

    // set default starting values

    const initialState = {
      source: 'Alachua County',
      compare: 'Miami-Dade County',
      baseline: 'Florida',
      view: 'page',
      width: window.innerWidth
    }

    window.addEventListener('resize', this.handleWindowSizeChange)

    this.state = parseStateFromUrl({ initialState })
  }

  onPlaceChange({ key, value }) {
    // update the url
    updateQueryStringBatch({
      [key]: value
    })

    this.setState({
      [key]: value
    })
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { source, compare, baseline, view, width } = this.state

    const colorScale = {
      [source]: boldRed,
      [compare]: boldBlue,
      [baseline]: veryDarkGray
    }

    const lines = reshapeData({ data }).filter(line =>
      [source, compare, baseline].includes(line.title)
    )

    lines.forEach(line => {
      line.color = colorScale[line.title]
      if (line.title === baseline) line.strokeDasharray = '4, 12'
    })

    const places = parsePlaces({ data, key: 'place' })

    return (
      <div className={styles.medianSalesPriceVis}>
        <Header title={title} />
        <Controls
          places={places}
          source={source}
          compare={compare}
          baseline={baseline}
          onPlaceChange={this.onPlaceChange.bind(this)}
          width={width}
          placeholderText={placeholderText}
        />
        <LineChart
          lines={lines}
          source={source}
          compare={compare}
          baseline={baseline}
          colorScale={colorScale}
          width={width}
          tooltipHeaderPrefix={tooltipHeaderPrefix}
        />
        <Legend width={width} height={20} lines={lines} />
        <Footer view={view} />
      </div>
    )
  }
}
